import {call, put, delay, fork, take, cancel} from "redux-saga/effects";
import {onError, safe} from "./handlerError";
import {GetResource, PutResource} from "../../utils/HttpUtil";
import {
    SET_BUYIN_LIST,
    REQUEST_BUYIN_LIST,
    REQUEST_BUYIN_LIST_FILTER,
    SET_BUYIN_LIST_FILTER,
    REQUEST_BUYIN_CSV_DOWNLOADER_URL,
    REQUEST_CANCEL_BUYIN_CSV_DOWNLOAD,
    SET_CANCEL_BUYIN_CSV_DOWNLOAD,
    SET_BUYIN_CSV_DOWNLOADER_URL,
    SET_ALLOW_CSV_CANCEL
} from "@actions/actionTypes";
import {getQuery} from "../../utils/CommonUtils";
import {getFormattedBody} from "@services/TableServices";
import {waitForFile} from "@services/CsvDownloadService";
import "./csvProcess";

let downloadTask

const takeLatest = (patternOrChannel, saga, ...args) => fork(function*() {
    while (true) {
        const action = yield take(patternOrChannel)
        if (patternOrChannel === REQUEST_BUYIN_CSV_DOWNLOADER_URL) {
            downloadTask = yield fork(saga, ...args.concat(action))
        } else {
            yield fork(saga, ...args.concat(action))
        }

    }
})


function* fetchBuyinList({params}) {
    let query = getQuery(params);
    const buyins = yield call(GetResource, `/buyin/stats?${query}`);
    yield put({type: SET_BUYIN_LIST, buyins})
}

function* fetchBuyinListFilter({params}) {
    const filter = yield call(GetResource, `/buyin/statsfilter`);
    yield put({type: SET_BUYIN_LIST_FILTER, filter})
}

function* fetchBuyinCsvDownloaderUrl({data, ...restProps}) {
    const checkProcessUrl = "/buyin/getreporturl";
    let id = restProps.processId;
    if (!id) {
        const formattedData = getFormattedBody(data)
        const query = getQuery(formattedData)
        id = yield call(GetResource, `/buyin/generatereport?${query}`);
    }
    window.CsvProcess.setProcess({
        actionType: REQUEST_BUYIN_CSV_DOWNLOADER_URL,
        processId: id,
        checkProcessUrl
    })
    yield put({type: SET_ALLOW_CSV_CANCEL, allow: {allowBuyIn: true}})
    const link = yield waitForFile(REQUEST_BUYIN_CSV_DOWNLOADER_URL, id, checkProcessUrl);
    yield put({type: SET_BUYIN_CSV_DOWNLOADER_URL, link})
    yield put({type: SET_CANCEL_BUYIN_CSV_DOWNLOAD})
    yield put({type: SET_ALLOW_CSV_CANCEL, allow: {allowBuyIn: false}})
    window.CsvProcess.removeProcess(id);
}

function* cancelBuyInCsvDownload(processId) {
    window.CsvProcess.setCanceled(processId);
    if (processId) {
        yield call(PutResource, `/bets/cancelreport?key=${processId}`);
    }
    window.CsvProcess.removeProcess(processId);
    yield delay(2000)
    yield put({type: SET_ALLOW_CSV_CANCEL, allow: {allowBuyIn: false}})
    yield put({type: SET_BUYIN_CSV_DOWNLOADER_URL, link: ""});
    yield put({type: SET_CANCEL_BUYIN_CSV_DOWNLOAD})
}

function* cancelFetching() {
    const processId = window.CsvProcess.getProcessIdByAction(REQUEST_BUYIN_CSV_DOWNLOADER_URL)
    yield cancel(downloadTask);
    yield cancelBuyInCsvDownload(processId)
}

function* buyinsSaga() {
    yield takeLatest(REQUEST_BUYIN_LIST, safe(onError, fetchBuyinList))
    yield takeLatest(REQUEST_BUYIN_LIST_FILTER, safe(onError, fetchBuyinListFilter))
    yield takeLatest(REQUEST_BUYIN_CSV_DOWNLOADER_URL, safe(onError, fetchBuyinCsvDownloaderUrl))
    yield takeLatest(REQUEST_CANCEL_BUYIN_CSV_DOWNLOAD, safe(onError, cancelFetching))
}

export default buyinsSaga